import { isDragActive as b } from "./atoms-v21112.js";
import { isNodeOrChild as g } from "./atoms-v21115.js";
import { isPrimaryPointer as v } from "./atoms-v2999.js";
import { setupGesture as E } from "./atoms-v21113.js";
import { isElementKeyboardAccessible as L } from "./atoms-v21116.js";
import { enableKeyboardPress as h } from "./atoms-v21117.js";
import { isPressing as i } from "./atoms-v21118.js";
function p(s) {
  return v(s) && !b();
}
function O(s, m, a = {}) {
  const [u, n, l] = E(s, a), w = (e) => {
    const t = e.currentTarget;
    if (!p(e) || i.has(t))
      return;
    i.add(t);
    const o = m(e), d = (r, P) => {
      window.removeEventListener("pointerup", c), window.removeEventListener("pointercancel", f), !(!p(r) || !i.has(t)) && (i.delete(t), typeof o == "function" && o(r, { success: P }));
    }, c = (r) => {
      d(r, a.useGlobalTarget || g(t, r.target));
    }, f = (r) => {
      d(r, !1);
    };
    window.addEventListener("pointerup", c, n), window.addEventListener("pointercancel", f, n);
  };
  return u.forEach((e) => {
    !L(e) && e.getAttribute("tabindex") === null && (e.tabIndex = 0), (a.useGlobalTarget ? window : e).addEventListener("pointerdown", w, n), e.addEventListener("focus", (o) => h(o, n), n);
  }), l;
}
export {
  O as press
};
